module.exports = __webpack_public_path__ + "0778e47f36c273489553fcc29213e103.svg";